import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { GtmService } from '@fcom/common/gtm';
import { ElementTypes, GaContext } from '@fcom/common/interfaces';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';
import { FinnairThemeService } from '@fcom/common/services';
import { stopPropagation } from '@fcom/core';
import { ModalButtons, NotificationButtonStyle, NotificationScale, NotificationTheme } from '@fcom/ui-components';

import { MoneyBackGuaranteeService } from '../../../services/money-back-guarantee.service';

const GTM_ELEMENT_NAME = '24-h-money-back-highlight';

@Component({
  selector: 'fin-money-back-notification',
  templateUrl: './money-back-notification.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoneyBackNotificationComponent {
  private readonly gtmService = inject(GtmService);
  private readonly moneyBackGuaranteeService = inject(MoneyBackGuaranteeService);
  private readonly themeService = inject(FinnairThemeService);

  readonly NotificationTheme = NotificationTheme;
  readonly NotificationScale = NotificationScale;
  readonly NotificationButtonStyle = NotificationButtonStyle;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly ModalButtons = ModalButtons;

  readonly isNewBrand = computed(() => this.themeService.siteTheme() !== FinnairTheme.LEGACY);

  show24hMoneyBackNotification = this.moneyBackGuaranteeService.isValidDate;
  modalOpen = signal(false);
  content$ = this.moneyBackGuaranteeService.content$;

  showModal(event: Event): void {
    stopPropagation(event);
    this.modalOpen.set(true);
    this.gtmService.trackElement(GTM_ELEMENT_NAME, GaContext.BOOKING_FLOW, ElementTypes.MODAL, undefined, 'open');
  }

  closeModal(): void {
    this.modalOpen.set(false);
    this.gtmService.trackElement(GTM_ELEMENT_NAME, GaContext.BOOKING_FLOW, ElementTypes.MODAL, undefined, 'close');
  }
}
